const initialState = {
  dashboard: {},
  applications: [],
  totalPages: 0,
  selectedApplication: null,
  reviewers: [],
  params: {}
}

const fisogReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FISOG_DASHBOARD':
      return { ...state, dashboard: action.data }
    case 'FISOG_APPLICATIONS':
      return { ...state, applications: action.data?.data || action.data || [], totalPages: action.totalPages, params: action.params }
    case 'FISOG_APPLICATION_DETAIL':
      return { ...state, selectedApplication: action.data }
    case 'FISOG_REVIEWERS':
      return { ...state, reviewers: action.data || [] }
    default:
      return state
  }
}

export default fisogReducer
